import React from "react";
import CardText from "../CardText";
import CardImage from "../CardImage";
import "./style.css";

function Card() {
  return (
    <div id="card">
      <CardText />
      <CardImage />
    </div>
  );
}

export default Card;
